import { HttpClient } from '@/shared/lib/http-client';

export const fetchCompanyProducts = async() => {
  const response = await HttpClient.get('/company-products');

  return response.data?.data;
};
